import { Box, Pagination, Typography } from '@mui/material'

interface Props {
  currentPage: number
  totalPages: number
  totalCount: number
  pageSize: number
  onPageChange: (page: number) => void
  isLoading?: boolean
}

export const BlogPagination = ({
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  isLoading = false,
}: Props) => {
  const startItem = (currentPage - 1) * pageSize + 1
  const endItem = Math.min(currentPage * pageSize, totalCount)

  if (totalPages <= 1) return null

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        mt: 4,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Hiển thị {startItem}-{endItem} trong tổng {totalCount} bài viết
      </Typography>

      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(_, page) => onPageChange(page)}
        disabled={isLoading}
        color="primary"
        shape="rounded"
        showFirstButton
        showLastButton
        sx={{
          '& .MuiPagination-ul': {
            justifyContent: 'center',
          },
        }}
      />
    </Box>
  )
}
